export default "__VITE_ASSET__BcXjj_p7__"